import { refreshSession } from '../api/client.ts';
import { session, type SessionStatus } from './session.ts';

let boot: Promise<SessionStatus> | null = null;

/**
 * Resuelve el estado de la sesión al abrir la app: si hay refresh token guardado, lo rota para obtener
 * un access token en memoria. Lo usan los *guards* de rutas.
 */
export function ensureSession(): Promise<SessionStatus> {
  const current = session.getState().status;
  if (current !== 'unknown') return Promise.resolve(current);
  boot ??= (async () => {
    if (session.getRefreshToken() === null) {
      session.clear();
      return 'anonymous';
    }
    const ok = await refreshSession();
    if (!ok && session.getState().status === 'unknown') session.markAnonymous();
    return session.getState().status;
  })().finally(() => {
    boot = null;
  });
  return boot;
}
